import { DeviceType } from "../types";
import { detect } from "detect-browser";

export const getDeviceType = () => {
  const ua = navigator.userAgent,
    up = navigator.platform;

  if (
    /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua) ||
    up === "iPad" ||
    (up === "MacIntel" && navigator.maxTouchPoints > 0)
  ) {
    return DeviceType.tablet;
  } else if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return DeviceType.mobile;
  }

  return DeviceType.desktop;
};

export const getOsVersion = (): string | null => {
  const os = detect()?.os;

  if (!os) {
    return null;
  }

  if (/Windows/.test(os)) {
    return /Windows (.*)/.exec(os)?.[1] ?? null;
  }

  if (["Mac OS", "Mac OS X", "Android"].includes(os)) {
    return (
      /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([._\d]+)/.exec(
        navigator.userAgent
      )?.[1] ?? null
    );
  }
  if (os === "iOS") {
    const data = /OS (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
    return data && data.length >= 2
      ? `${data[1]}.${data[2]}.${data[3] ?? 0}`
      : null;
  }

  return null;
};
